import { css } from 'styled-components'
import { styles } from '../../styles/themes/style'

/** Same trigger box as the contacts filter: 40px height, shared horizontal padding. */
export const filterFieldControlStyles = css`
    & .dropdown,
    & .dropup {
        width: 100%;
        min-width: 0;
        background-color: transparent !important;
    }

    & .dropdown-toggle,
    & .dropdownWrapperReference {
        width: 100%;
        min-width: 0;
        overflow: hidden;
    }

    & .dropdown-toggle {
        height: 40px !important;
        min-height: 40px !important;
        padding: 0 12px !important;
        border-radius: 8px !important;
        outline: none !important;
        box-shadow: none !important;
        text-align: left !important;
        border: 1px solid ${styles.colors.black200} !important;
        background-color: ${({ theme }) => theme.secondaryColor} !important;
        box-sizing: border-box;
        color: ${styles.colors.black600} !important;
        font-weight: 500 !important;
        font-size: 14px !important;

        &:hover,
        &:focus {
            outline: none !important;
            border-color: ${styles.colors.black300} !important;
            background-color: ${styles.colors.black100} !important;
            color: ${styles.colors.black600} !important;
        }
    }

    & .dropdownWrapperReference {
        gap: 8px;
        height: 100%;
        font-weight: 400;
        color: ${styles.colors.black600};
    }

    & [class*='-control'] {
        height: 40px !important;
        min-height: 40px !important;
        border-radius: 8px !important;
        border: 1px solid ${styles.colors.black200} !important;
        box-shadow: none !important;
        padding: 0 8px !important;
        gap: 8px;
        box-sizing: border-box;
        background-color: ${({ theme }) => theme.secondaryColor} !important;

        &:hover {
            border-color: ${styles.colors.black300} !important;
            background-color: ${styles.colors.black100} !important;
        }
    }

    & [class*='-ValueContainer'] {
        min-width: 0;
        overflow: hidden;
        padding: 0 !important;
    }

    & [class*='-singleValue'] {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 !important;
        position: static !important;
        transform: none !important;
    }

    & [class*='-IndicatorsContainer'] {
        flex-shrink: 0;
    }

    & [class*='-indicatorContainer'] {
        padding: 0 !important;
    }
`
